export default {
  path: '/dashboard',
  component: () => import('../../views/dashBoard/dashboard-router.vue'),
  children: [
    {
      path: '',
      name: 'DashBoard',
      component: () => import('@/views/dashBoard/pages/DashBoard.vue'),
      meta: {
        auth: true,
        role: 'SUPER_ADMIN'
      }
    }
  ]
}
